import { render, staticRenderFns } from "./selectClinic.vue?vue&type=template&id=bf9837f8&"
import script from "./selectClinic.vue?vue&type=script&lang=js&"
export * from "./selectClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports